import { render, staticRenderFns } from "./LookbookGrid.vue?vue&type=template&id=2968b9fe&scoped=true&"
import script from "./LookbookGrid.vue?vue&type=script&lang=js&"
export * from "./LookbookGrid.vue?vue&type=script&lang=js&"
import style0 from "./LookbookGrid.vue?vue&type=style&index=0&id=2968b9fe&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968b9fe",
  null
  
)

export default component.exports